import { SET_USER_ID, SET_FINGERPRINT_ID, AUTHENTICATION_RESET_STATE } from '../constants/authentication';

const initialState = {
  userId: null,
  fingerprintId: null
};

const authentication = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_ID:
      return {
        ...state,
        userId: action.userId
      };

    case SET_FINGERPRINT_ID:
      return {
        ...state,
        fingerprintId: action.fingerprintId
      }
    case AUTHENTICATION_RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default authentication;
